import { Component, AfterViewInit } from '@angular/core';
import { Hashtag, HashtagsService } from './hashtags.service';

@Component({
  selector: 'app-hashtags',
  templateUrl: '../templates/hashtags.component.html',
  styleUrls: ['../styles/components/hashtags.component.less'],
  providers: [HashtagsService]
})
export class HashtagsComponent implements AfterViewInit {
  hashtags: Hashtag[] = [];

  constructor(private hashtagsService: HashtagsService) {}

  public async ngAfterViewInit() {
    try {
      const hashtags = await this.hashtagsService.get();
      this.hashtags = hashtags.map((t: Hashtag) => {
        t.href = `https://zolotoykod.ru/tag/${t._id}/`;
        return t;
      });
    } catch (e) {}
  }
}
